import React from 'react';

import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';
import DownloadCTA from '../../components/DownloadCTA';
import heroDesktop from './assets/hero-desktop.png';

const HeroSection = () => (
  <section className="flex-1 flex items-center justify-center p-4 md:p-4 relative pt-28 md:pt-28 lg:pt-0">
    {/* Decorative background shape */}
    <div className="hidden md:block absolute right-0 top-12 bottom-0 my-auto h-[350px] w-[calc(50vw-80px)] bg-[#E7E1DB] rounded-l-[128px]"></div>

    <div className="max-w-[1280px] w-full grid md:grid-cols-2 gap-10 md:gap-20 items-center relative z-10">
      <div className="space-y-6">
        <Title className="leading-none">
          O app que é tudo pra você.
          <br />
          Do estacionamento ao cafezinho.
        </Title>
        <Subtitle className="text-xl md:text-3xl text-[#003424] font-light leading-none">
          Com o Multi, sua experiência ao visitar os shoppings Multiplan fica ainda melhor.
        </Subtitle>

        <DownloadCTA className="mt-10" />
      </div>
      <div className="flex justify-center items-center z-10">
        <img
          src={heroDesktop}
          alt="Multi App Preview"
          className="h-auto max-h-[600px] md:max-w-none lg:max-w-[600px] xl:max-w-[800px]"
        />
      </div>
    </div>
  </section>
);

export default HeroSection;
